/**
 * 관리자 매칭 성과 분석 (독립 페이지, 타입 탭)
 * ($j.Pages.Admin.MatchStat / body data-page-name="MatchStat")
 *
 * 타입(NC/NS/TC/TQ) × 업종(전체/장비별) 별 지역 발주량 + 수주 빈부격차 + TOP 수주 회원.
 */
import Util from '../../Common/Util';
export default class MatchStat {
    constructor() {
        this.type = 'NC';
        this.car = '';
        this.sidoChart = null;
        this.distChart = null;
        this.trendChart = null;
        this.memberTrendChart = null;
        this.$topTable = null;
        this.$ordersTable = null;
        this.allSido = [];
    }

    initialize() {
        this._bindUi();
        this._load();
    }

    _bindUi() {
        $('#msRefresh').on('click', () => this._load(true));
        // 기간선택 드롭다운과 '특정 월'은 서로 배타적 — 드롭다운을 다시 고르면 특정 월 지정을 푼다.
        // 특정 월은 평소엔 달력 아이콘만 보이다가, 고르면 아이콘이 "YYYY년 MM월" 라벨로 바뀐다.
        $('#msPeriod').on('change', () => this._setEndMonth('', true));
        $('#msEndMonth').on('change', () => this._syncEndMonthLabel(true));
        $('#msEndMonthClear').on('click', () => this._setEndMonth('', true));
        // input 은 화면에 안 그리므로(1px) 버튼이 대신 picker 를 연다
        $('#msEndMonthBtn').on('click', () => {
            const el = document.getElementById('msEndMonth');
            if (el.showPicker) el.showPicker();   // Chrome/Edge 99+
            else el.focus();                       // 폴백 — 최소한 포커스는 가서 키보드로 입력 가능
        });
        $('#msTabs').on('click', 'a', (e) => {
            const $a = $(e.currentTarget);
            this.type = String($a.data('type'));
            $('#msTabs a').removeClass('active');
            $a.addClass('active');
            this._load();
        });
        // 업종 버튼
        $('#msCarBtns').on('click', 'button', (e) => {
            const $b = $(e.currentTarget);
            this.car = String($b.data('car') || '');
            $('#msCarBtns button').removeClass('active');
            $b.addClass('active');
            this._load();
        });
        $('#msSidoMore').on('click', () => this._openSidoModal());
        // TOP 표 수주건수 클릭 → 그 회원 수주 오더목록 모달
        $(document).on('click.msstat', '.ms-soojoo', (e) => {
            const $a = $(e.currentTarget);
            this._openSoojooModal(Number($a.data('mb')), String($a.data('name') || ''));
        });
        // 회원 검색(TOP표 200명 밖의 회원도) → 월/년별 수주건수 추이
        $j.F.Admin.Util.memberSearch('msMemberKwd');
        $('#msMemberSearchBtn').on('click', () => this._searchMemberTrend());
        $('#msMemberKwd').on('keydown', (e) => {
            if (e.key === 'Enter') { e.preventDefault(); this._searchMemberTrend(); }
        });
        // 지웠다 다시 칠 때 편하도록 × — 자동완성이 값을 채울 땐 input 이벤트가 안 떠서
        // 타이핑(input/keyup)과 자동완성 선택 뒤 포커스가 빠지는 순간(blur) 둘 다 잡는다
        $('#msMemberKwd').on('input keyup blur', () => this._syncMemberKwdClear());
        $('#msMemberKwdClear').on('click', () => {
            $('#msMemberKwd').val('');
            this._syncMemberKwdClear();
        });
        $('#msMemberTrendClose').on('click', () => $('#msMemberTrendRow').addClass('ms-off'));
    }

    /** 특정 월 입력값을 바꾸고(빈 문자열=해제) 라벨을 맞춘 뒤, 필요하면 다시 로드한다. */
    _setEndMonth(val, reload) {
        $('#msEndMonth').val(val);
        this._syncEndMonthLabel(reload);
    }

    /** #msEndMonth 값 → "YYYY년 M월" 라벨 표시 + 해제(×) 버튼 노출. 아이콘만 남기고 값은 라벨이 대신 보여준다. */
    _syncEndMonthLabel(reload) {
        const v = String($('#msEndMonth').val() || ''); // "2026-08" 또는 ''
        const m = v.match(/^(\d{4})-(\d{2})$/);
        $('#msEndMonthLabel').text(m ? `${m[1]}년 ${parseInt(m[2], 10)}월` : '');
        $('#msEndMonthClear').toggle(!!m);
        if (reload) this._load();
    }

    /**
     * 기간 파라미터 — '특정 월'(#msEndMonth)이 지정돼 있으면 그 달 하나만(unit=month, periods=1, end),
     * 아니면 기간선택 드롭다운(#msPeriod, 'unit:periods') 값을 그대로 쓴다.
     * TOP표·카드·지역별 등 이 화면 전체가 최근 N개월 '합계'가 아니라 원하는 시점 하나로 보이도록
     * 세 요청(_load/_searchMemberTrend/_openSoojooModal)이 항상 같은 값을 쓰게 여기서 만든다.
     */
    _periodParams() {
        const end = String($('#msEndMonth').val() || '').replace('-', ''); // "2026-08" → "202608"
        if (end.length === 6) return { unit: 'month', periods: 1, end };
        const [unit, periods] = String($('#msPeriod').val()).split(':');
        return { unit, periods };
    }

    async _load(nocache = false) {
        const p = this._periodParams();
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/matching/data', type: 'get',
                data: { type: this.type, ...p, car: this.car, ...(nocache ? { nocache: 1 } : {}) }
            });
            if (!res.ok) return;
            $('#msTabLabel').text(res.label || this.type);
            const lbl = [];
            if (p.end) lbl.push(`${p.end.slice(0, 4)}년 ${parseInt(p.end.slice(4, 6), 10)}월만`);
            if (res.car) lbl.push(res.car);
            $('#msPeriodLbl').text(lbl.length ? ` · ${lbl.join(' · ')}` : '');
            this._renderCards(res);
            this._renderSido(res.by_sido || []);
            this._renderDist(res.fairness || {});
            this._renderTrend(res.trend || []);
            this._renderTop(res.top_winners || []);
            if (res.cached_at) $('#msCachedAt').text(`집계시각 ${res.cached_at}`);
        } catch (e) {
            console.error('매칭 성과 로드 실패', e);
        }
    }

    _renderCards(res) {
        const tot = res.total || {}, f = res.fairness || {};
        $('#msTotOrders').text(this._comma(tot.orders) + '건');
        $('#msTotSub').text(`수주 ${this._comma(tot.won)}건`);
        $('#msWinners').text(this._comma(tot.winners) + '명');
        $('#msAvg').text((f.avg ?? 0) + '건');
        $('#msGini').text(f.gini ?? 0);
        $('#msGiniSub').text(`상위10%가 ${f.top10_share ?? 0}% 차지`);
    }

    _renderSido(rows) {
        this.allSido = rows;
        const TOP = 8;
        const top = rows.slice(0, TOP);
        this.sidoChart = this._barChart('msSidoChart', this.sidoChart,
            top.map(r => r.sido), top.map(r => Number(r.orders)), 'rgba(13,110,253,.75)', '발주');
        if (rows.length > TOP) {
            $('#msSidoMore').show();
            $('#msSidoMoreLbl').text(`(상위 ${TOP} / 전체 ${rows.length})`);
        } else {
            $('#msSidoMore').hide();
            $('#msSidoMoreLbl').text('');
        }
    }

    _openSidoModal() {
        const rows = this.allSido || [];
        const total = rows.reduce((s, r) => s + Number(r.orders), 0);
        const body = rows.map((r, i) => `<tr>
            <td>${i + 1}</td>
            <td>${r.sido}</td>
            <td class="text-right">${this._comma(r.orders)}</td>
            <td class="text-right">${total > 0 ? (Number(r.orders) / total * 100).toFixed(1) : 0}%</td>
        </tr>`).join('');
        // vh 는 --adm-zoom 으로 나눈다 (admin/base/_fontsize.scss) — 폴백 1 이라 보통은 그대로
        const html = `<div style="max-height:calc(62vh / var(--adm-zoom, 1));overflow:auto;">
            <table class="table table-sm table-bordered">
                <thead><tr><th>순위</th><th>지역</th><th class="text-right">발주</th><th class="text-right">비중</th></tr></thead>
                <tbody>${body || '<tr><td colspan="4" class="text-center text-muted">없음</td></tr>'}</tbody>
            </table></div>`;
        $j.Ui.JBModal.html('ms-sido-modal', html, `지역별 발주량 — 전체 ${rows.length}개 · ${this._comma(total)}건`, { width: '460px' });
    }

    _renderDist(f) {
        $('#msShareSub').text(f.winners ? `(상위1% ${f.top1_share}% · 상위10% ${f.top10_share}% 차지)` : '');
        const buckets = f.buckets || [];
        this.distChart = this._barChart('msDistChart', this.distChart,
            buckets.map(b => b.label), buckets.map(b => Number(b.members)), 'rgba(220,53,69,.7)', '회원수', false);
    }

    _renderTrend(trend) {
        const ctx = document.getElementById('msTrendChart').getContext('2d');
        if (this.trendChart) this.trendChart.destroy();
        this.trendChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: trend.map(r => this._fmtBucket(r.bucket)),
                datasets: [{ label: '발주', data: trend.map(r => Number(r.orders)), backgroundColor: 'rgba(25,135,84,.7)' }]
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
                plugins: { legend: { display: false } }
            }
        });
    }

    /** 검색어 있을 때만 × 노출 — 자동완성으로 채워졌을 때도 잡히게 여러 지점에서 부른다 */
    _syncMemberKwdClear() {
        $('#msMemberKwdClear').toggle($('#msMemberKwd').val().length > 0);
    }

    /** 회원 검색 → 월/년별 수주건수 추이 (선택된 탭·기간·업종 기준) */
    async _searchMemberTrend() {
        const kwd = String($('#msMemberKwd').val() || '').trim();
        this._syncMemberKwdClear();
        if (!kwd) return;
        const p = this._periodParams();
        let res;
        try {
            res = await $.ajax({
                url: '/adm/ajax/stat/matching/member-trend', type: 'get',
                data: { kwd, type: this.type, ...p, car: this.car }
            });
        } catch (e) {
            console.error('회원 수주 추이 로드 실패', e);
            Util.swalert('조회 중 오류가 발생했습니다.');
            return;
        }
        if (!res || !res.ok) {
            Util.swalert((res && res.msg) || '조회에 실패했습니다.');
            return;
        }
        this._renderMemberTrend(res);
    }

    _renderMemberTrend(res) {
        const members = res.members || [];
        const trend = res.trend || [];
        const $row = $('#msMemberTrendRow');
        $row.removeClass('ms-off');   // .row(flex) 라 show() 를 쓰지 않는다 — sass 의 .ms-off 를 뗀다
        // 검색창 바로 아래 있어도 리스트가 길면 화면 밖일 수 있다 — 검색했다는 걸 바로 보여준다
        $row[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        if (!members.length) {
            $('#msMemberTrendSub').text('(검색결과 없음)');
        } else {
            const names = members.map(m => $j.F.Admin.Member.Pop.cell(m.mb_no, m.mem_name)).join(', ');
            $('#msMemberTrendSub').html(`(${names} · 총 ${this._comma(res.total)}건 · 월평균 ${res.avg}건)`);
        }

        const ctx = document.getElementById('msMemberTrendChart').getContext('2d');
        if (this.memberTrendChart) this.memberTrendChart.destroy();
        this.memberTrendChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: trend.map(r => this._fmtBucket(r.bucket)),
                datasets: [{ label: '수주', data: trend.map(r => Number(r.wins)), backgroundColor: 'rgba(111,66,193,.75)' }]
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
                plugins: { legend: { display: false } }
            }
        });
    }

    _renderTop(rows) {
        $('#msTopCount').text(`상위 ${this._comma(rows.length)}명`);
        if (this.$topTable) { this.$topTable.destroy(); $('#msTopTable').empty(); }
        this.$topTable = new DataTable('#msTopTable', {
            data: rows,
            columns: [
                { data: 'rank', title: '#' },
                {
                    data: 'mem_name', title: '이름',
                    render: (v, t, r) => $j.F.Admin.Member.Pop.cell(r.mb_no, v)
                },
                { data: 'mem_car_type', title: '장비', render: (v) => Util.escapeHtml(v || '-') },
                {
                    data: 'wins', title: '수주',
                    render: (v, t, r) => {
                        const n = Number(v);
                        const safe = String(r.mem_name || '').replace(/"/g, '&quot;');
                        return `<a href="javascript:void(0)" class="ms-soojoo" data-mb="${r.mb_no}" data-name="${safe}">${this._comma(n)}</a>`;
                    }
                },
                { data: 'wins_avg', title: '월평균', render: (v) => `${v}건` },
                { data: 'share', title: '점유율', render: (v) => `${v}%` },
            ],
            order: [[3, 'desc']],
            pageLength: 25,
            lengthChange: true,
            searching: true,
            autoWidth: false,
        });
    }

    async _openSoojooModal(mbNo, name) {
        if (!mbNo) return;
        const p = this._periodParams();
        let res;
        try {
            res = await $.ajax({
                url: '/adm/ajax/stat/matching/member-orders', type: 'get',
                data: { mb_no: mbNo, type: this.type, ...p, car: this.car }
            });
        } catch (e) {
            console.error('수주 오더목록 로드 실패', e);
            return;
        }
        if (!res || !res.ok) return;
        const rows = res.data || [];
        const carLbl = this.car ? ` ${this.car}` : '';
        const title = `${name || ('#' + mbNo)} · ${this.type}${carLbl} 수주 ${this._comma(rows.length)}건`;
        // 공용 오더목록 모달 (발주자 컬럼)
        $j.F.Admin.Order.OrderListModal.show('ms-orders-modal', title, rows, {
            lastColTitle: '발주자', lastColField: 'bal_owner_name', lastColNoField: 'order_owner_num', emptyName: '-',
            pageLength: 10, emptyText: '수주 오더 없음',
        });
    }

    _barChart(canvasId, prev, labels, data, color, label, horizontal = true) {
        const ctx = document.getElementById(canvasId).getContext('2d');
        if (prev) prev.destroy();
        const valueAxis = horizontal ? 'x' : 'y';
        const catAxis = horizontal ? 'y' : 'x';
        return new Chart(ctx, {
            type: 'bar',
            data: { labels, datasets: [{ label, data, backgroundColor: color }] },
            options: {
                indexAxis: horizontal ? 'y' : 'x',
                responsive: true, maintainAspectRatio: false,
                scales: {
                    [valueAxis]: { beginAtZero: true, ticks: { precision: 0 } },
                    [catAxis]: { ticks: { autoSkip: false } },
                },
                plugins: { legend: { display: false } }
            }
        });
    }

    _fmtBucket(b) {
        const s = String(b);
        if (s.length === 6) return `${s.slice(0, 4)}.${s.slice(4)}`;
        if (s.length === 4) return `${s}년`;
        return s;
    }

    _comma(n) { return Number(n || 0).toLocaleString(); }

    destroy() {
        ['sidoChart', 'distChart', 'trendChart', 'memberTrendChart'].forEach(k => {
            if (this[k]) { this[k].destroy(); this[k] = null; }
        });
        if (this.$topTable) { this.$topTable.destroy(); this.$topTable = null; }
        $j.F.Admin.Order.OrderListModal.destroy();
        $(document).off('.msstat');
        if ($j.Ui.JBModal) $j.Ui.JBModal.close();
    }
}
